import React, { useEffect, useState, Fragment, useContext } from 'react';
import Layout from 'components/sales/layout/layout';
import { toast, ToastContainer } from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import FormSection from 'components/sales/formSection/formSectionNew';
import TextAreaInput from 'components/sales/Input/textAreaInput/textAreaInput';
import ConstantInput from 'components/sales/Input/constantInput/constantInput';
import DropDownInput from 'components/sales/Input/dropDownInput/dropDownInput';
import 'react-toastify/dist/ReactToastify.css';
import DocumentView from "../../../components/sales/downloadDocView/documentView";
import ModalPop from 'components/sales/modal/modal';
import localization from 'assets/localization/localization';
import { Button } from 'react-bootstrap';
import FileUpload from 'components/sales/fileUpload/fileUpload';
import DatePicker from "components/sales/datePicker/datePicker";
import Images from 'assets/images/imageData';
import { Link } from "react-router-dom";

const InspectionFormMail = ({
  match,
  getInspectionForm,
  getInspectionForms,
  sendInspectionMail
}) => {
  const [isModal, setIsModal] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [formData, setData] = useState({ request_id: 0, body: "" });
  useEffect(() => {
    (async () => {
      setIsLoading(true);
      await getInspectionForm(match.params.id);
      setIsLoading(false);
    })();
  }, [])
  useEffect(() => {
     setData({
      ...formData, body:
        `${getInspectionForms?.mail_template}`
     });
    // setData({
    //   ...formData, body:
    //     `Hi ${getInspectionForms?.sales_manager_name}
 
    // This is to apprise you here that our team has visited the ${getInspectionForms?.business_name} site for integration feasibility of barriers and readers, below are the observations:
      
    // 1. Total Number of  barriers are there in the society, Gate wise feasibility and requirement is mentioned in the report.
    // 2. Barriers can be integrated with our system. (Refer report for other details).
    // 3. Gate wise civil work and wiring reuse status mentioned in the report.
    // 4. Push Button required  along with wiring.
    // 5. Complete wiring needs to be replaced.
    // 6. UPS is Required.
    // 7. We can take Non comprehensive AMC for working barriers only. (Refer report for gate wise details).
    // 8. This report is valid only for 21 days.
    // 9. Integration checklist is attached.
    
    // All other relevant details are available in the report attached.
    // Inspection against the ${getInspectionForms?.business_name} is completed by site engineer ${getInspectionForms?.inspected_by}.
      
    // Please find relevant details 
      
    // Business Name : ${getInspectionForms?.business_name}
    // Requested by : ${getInspectionForms?.sales_manager_name}
    // Inspection Engineer : ${getInspectionForms?.inspected_by}
    // Requested Date : ${new Date().toJSON().slice(0, 10)}
    // `})
  }, [getInspectionForms])
  const headerBtns = () => {
    return (
      <Button onClick={handleSubmit} className="btn btn-primary">
        Send Mail
        <img src={Images?.ArrowRight} alt="" />
      </Button>
    );
  };
  const handleSubmit = () => {
    if (formData.body == '') {
      toast.error('Fill mail message!');
      return;
    } else {
      (async () => {
        setIsLoading(true);
        const res = await sendInspectionMail(formData);
        setIsLoading(false);
        if (res) {
          setIsModal(true);
        } else {
          toast.error('Some error occurred. Please try again later.');
          return;
        }
      })();
    }
  };
  useEffect(() => {
    if (match.params.id !== undefined) {
      setData({ ...formData, request_id: match.params.id });
    }
  }, [match.params.id]);
  return (
    <Layout
      title='Inpection Requests'
      Buttons={headerBtns}
      isGoback
      isLoading={isLoading}
    >
      <FormSection title='Mail Inspection Form'>
        <TextAreaInput
          inputValue={formData?.body}
          rows={20}
          type="text"
          label='Mail Body'
          handleChange={(e) => setData({ ...formData, body: e.target.value })}
          errorMsg='Additional Remarks required'
        />
      </FormSection>

      <ModalPop
        title={localization.conf}
        show={isModal}
        handleModalHide={() => setIsModal(false)}
        keyboard
        backdrop>
        <div className="text-center">
          <div className="success">
            <img src={Images?.tick} alt="" />
          </div>
          <h5>Mail Sent Successfully</h5>
          <Link to={`/dashboard/inspection-requests`} className="btn btn-primary mb-4">View Inspection Requests</Link>
        </div>
      </ModalPop>

    </Layout>
  );
};

export default InspectionFormMail;

